/**
 * Assert a value is non-null/undefined and return it narrowed.
 *
 * Main use: TanStack Query `queryFn`. The `enabled` gate already guarantees
 * the repo / id is defined when the query runs, but the TS compiler can't
 * see through the `enabled` contract — so without help we'd be forced
 * into `repo!.listAll()` with an unexplained non-null assertion.
 *
 * Replace `repo!.listAll()` with `assertPresent(repo).listAll()` and the
 * intent is self-documenting: the call only runs when the value exists,
 * and if the guard ever breaks the thrown error names the culprit.
 */
export function assertPresent<T>(
  value: T | null | undefined,
  name = 'value',
): T {
  if (value == null) {
    throw new Error(`${name} unexpectedly null/undefined`)
  }
  return value
}
